
    <div class="detsis-popup-area">
      <div class="detsis-ctl-area">
        <span>Detsis No :</span>
        <dk-ctl-gen-kontrol  [controlName]="'GenDetsisTanim'"
        [labelMode]="labelMode"
        [isReadOnly]="selectedDetsisNo?true:false"
        [type]="'number'"
       [labelText]="'Detsis No'"
       [code]="detsisBirim?.DetsisNo?detsisBirim.DetsisNo:selectedDetsisNo"
       (dataResult)="getDetsisBirim($event)"></dk-ctl-gen-kontrol>
      </div>
 
       <div class="form-area">
         <dx-form
         *ngIf="defaultBirim"
         #form
         [labelMode]="labelMode"
         [labelLocation]="labelLocation"
         [formData]="defaultBirim"
         [readOnly]="true"
         [colCount]="1"
         class="form"
         id="form"
       >
         <dxi-item itemType="group" [colSpan]="1" caption="Mevcut Birim Bilgileri">
           <dxi-item
             dataField="KimlikNo"
             [label]="{ text: 'KimlikNo' }"
             [editorType]="'dxNumberBox'"
             
           ></dxi-item>
           <dxi-item
             dataField="KepEposta"
             [label]="{ text: 'Kep E-posta' }"
             
           ></dxi-item>
           <dxi-item  dataField="Ad" [label]="{ text: 'Mevcut Birim Adı' }" 
           editorType="dxTextArea"></dxi-item>
          </dxi-item>
           <dxi-item itemType="group" [colSpan]="1" caption="Mevcut Birim İletişim Bilgileri">
           <dxi-item
             dataField="BirimAdres"
             [label]="{ text: 'Adres' }"
             
           ></dxi-item>
           <dxi-item
             dataField="BirimEPosta"
             [label]="{ text: 'E-posta' }"
             
           ></dxi-item>
           <dxi-item
             dataField="BirimWebAdres"
             [label]="{ text: 'Web Adres' }"
             
           ></dxi-item>
           <dxi-item itemType="group" cssClass="form-multiple-row" [colCount]="5">
             <dxi-item
             [colSpan]="2"
             [label]="{ text: 'Telefon' }"
             dataField="TelAlanKod"
             >
             </dxi-item>
               <dxi-item
               [colSpan]="3"
               [label]="{ text: ' ' }"
               dataField="TelNo"
                   >
               </dxi-item>
           </dxi-item>
           <dxi-item itemType="group" cssClass="form-multiple-row" [colCount]="5">
             <dxi-item
             [colSpan]="2"
             [label]="{ text: 'Fax' }"
             dataField="FaxAlanKod"
             >
             </dxi-item>
               <dxi-item
               [colSpan]="3"
               [label]="{ text: ' ' }"
               dataField="FaxNo"
                   >
               </dxi-item>
           </dxi-item>
         </dxi-item>
       </dx-form>
       <div class="arrow-area" *ngIf="defaultBirim">
        <span class="secim-text">SEÇİM</span>
        <i class="dx-icon-sortup" style="transform: rotate(-90deg); display: inline-block; font-size: 24px"></i>
      <dx-check-box [value]="true" [readOnly]="true"></dx-check-box>
      <dx-check-box [(value)]="kepCheckBox"></dx-check-box>
      <dx-check-box [(value)]="adCheckBox"></dx-check-box>
      <dx-check-box [(value)]="adresCheckBox"></dx-check-box>
      <dx-check-box [(value)]="mailCheckBox"></dx-check-box>
      <dx-check-box [(value)]="webCheckBox"></dx-check-box>
      <dx-check-box [(value)]="telCheckBox"></dx-check-box>
      <dx-check-box [(value)]="faxCheckBox"></dx-check-box>
        <!-- <i class="dx-icon-to"></i>
        <i class="dx-icon-to"></i>
        <i class="dx-icon-to"></i>
        <i class="dx-icon-to"></i>
        <i class="dx-icon-to"></i>
        <i class="dx-icon-to"></i>
        <i class="dx-icon-to"></i> -->
       </div>
       <dx-form
       #form
       [ngClass]="defaultBirim?'form':'one-form'"
       [labelMode]="labelMode"
       [labelLocation]="labelLocation"
       [formData]="detsisBirim"
       [colCount]="1"
       id="form"
     >
       <dxi-item itemType="group" [colSpan]="1" caption="Detsis Birim Bilgileri">
         <dxi-item
           dataField="DetsisNo"
           [label]="{ text: 'Detsis No' }"
           [editorType]="'dxNumberBox'"
           [editorOptions]="{ readOnly: true }"
           
         ></dxi-item>
         <dxi-item
           dataField="KepAdres"
           [label]="{ text: 'Kep Adresi' }"
           
         ></dxi-item>
         <dxi-item  dataField="KurumHiyarersik" [label]="{ text: 'Güncel Detsis Adı' }" 
          editorType="dxTextArea"></dxi-item>
        </dxi-item>
         <dxi-item itemType="group" [colSpan]="1" caption="Detsis Birim İletişim Bilgileri">
          <dxi-item
          dataField="detsisBirimAdres"
            [label]="{ text: 'Adres' }"
          ></dxi-item>
          <dxi-item
            dataField="detsisBirimEPosta"
            [label]="{ text: 'E-posta' }"
            
          ></dxi-item>
          <dxi-item
            dataField="detsisBirimWebAdres"
            [label]="{ text: 'Web Adres' }"
            
          ></dxi-item>
          <dxi-item itemType="group" cssClass="form-multiple-row" [colCount]="5">
            <dxi-item
            [colSpan]="2"
            [label]="{ text: 'Telefon' }"
            dataField="detsisBirimTelAlan"
            >
            </dxi-item>
              <dxi-item
              [colSpan]="3"
              [label]="{ text: ' ' }"
              dataField="detsisBirimTelNo"
                  >
              </dxi-item>
          </dxi-item>
          <dxi-item itemType="group" cssClass="form-multiple-row" [colCount]="5">
            <dxi-item
            [colSpan]="2"
            [label]="{ text: 'Fax' }"
            dataField="detsisBirimFaxAlan"
            >
            </dxi-item>
              <dxi-item
              [colSpan]="3"
              [label]="{ text: ' ' }"
              dataField="detsisBirimFaxNo"
                  >
              </dxi-item>
          </dxi-item>
      
       </dxi-item>
     </dx-form>
       </div>
       <div class="info-text-area" *ngIf="defaultBirim">
        <span>DİKKAT! '{{defaultBirim?.KimlikNo}}' kimlik nolu mevcut birim bilgileri güncellemeniz durumunda işaretlediğiniz bilgilerle değişecektir.</span>
       </div>
       <div class="btn-area"> 
        <dx-button stylingMode="contained" [text]="isHaveBirim?'Güncelle':'Kaydet'" type="success" [width]="120"
        (onClick)="saveClick()">
    </dx-button>
       </div>
    </div>
    
    